module.exports = __webpack_public_path__ + "tw.svg?c4c781947d073eb65233abb4788791d2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/tw.svg
// module id = 961
// module chunks = 27